export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://hammerhead-app-nt8ss.ondigitalocean.app';

/** Frontend base URL for SEO (canonical, JSON-LD). Override with REACT_APP_SITE_URL if needed. */
export const SITE_BASE_URL = process.env.REACT_APP_SITE_URL || 'https://www.bluecompassrv.com/support-library';

export const formatUrlPart = (str) => (str && String(str).toLowerCase().replace(/\s+/g, '-')) || '';

/** Normalize transcript _id whether API returns string or MongoDB-style { $oid: string }. */
export const getTranscriptId = (item) => {
  if (item == null) return '';
  const id = item._id;
  if (id != null && typeof id === 'object' && typeof id.$oid === 'string') return id.$oid;
  return typeof id === 'string' ? id : String(id);
};

const checkOk = (res, parseAsJson = true) => {
  if (!res.ok) throw new Error(`Request failed: ${res.status}`);
  return parseAsJson ? res.json() : res.text();
};

export const getBrands = () => {
  return fetch(`${API_BASE_URL}/api/brands`).then(res => checkOk(res));
};

export const getModelsForBrand = (brand) => {
  const formattedBrand = formatUrlPart(brand);
  return fetch(`${API_BASE_URL}/api/brands/${formattedBrand}/models`).then(res => checkOk(res));
};

export const getTranscriptsForModel = (brand, model) => {
  const formattedBrand = formatUrlPart(brand);
  const formattedModel = formatUrlPart(model);
  return fetch(`${API_BASE_URL}/api/brands/${formattedBrand}/models/${formattedModel}`).then(res => checkOk(res));
};

export const getTranscript = (brand, model, transcriptId) => {
  const formattedBrand = formatUrlPart(brand);
  const formattedModel = formatUrlPart(model);
  return fetch(`${API_BASE_URL}/api/brands/${formattedBrand}/models/${formattedModel}/${transcriptId}`).then(res => checkOk(res));
};

export const searchTranscripts = (query) => {
  const formattedQuery = formatUrlPart(query);
  return fetch(`${API_BASE_URL}/api/transcripts/search?query=${encodeURIComponent(formattedQuery)}`).then(res => checkOk(res));
};

export const getSitemap = () => {
  return fetch(`${API_BASE_URL}/api/sitemap`).then(res => checkOk(res, false));
};

export const getVotesForTranscript = (transcriptId) => {
  return fetch(`${API_BASE_URL}/api/transcripts/${transcriptId}/votes`).then(res => checkOk(res));
};

export const castVote = (transcriptId, voteType, email) => {
    return fetch(`${API_BASE_URL}/api/transcripts/${transcriptId}/vote`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ voteType, email }),
    }).then(res => {
    if (!res.ok) throw new Error('Vote failed');
    return res.json();
  });
};

export const registerUser = (email, transcriptId) => {
    return fetch(`${API_BASE_URL}/api/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, transcriptId })
  })
    .then(response => {
      if (!response.ok) throw new Error(`Status ${response.status}: Registration failed`);
      return response.json();
    })
    .catch(error => {
      console.error('Error registering user:', error);
      throw error;
    });
};

export const getUserStatusForTranscript = (transcriptId, email) => {
  return fetch(`${API_BASE_URL}/api/transcripts/${transcriptId}/user-status?email=${encodeURIComponent(email)}`)
    .then(response => {
      if (!response.ok) throw new Error(`Status ${response.status}: User status not found`);
      return response.json();
    })
    .catch(error => {
      console.error('Error fetching user status:', error);
      return { registered: false, voted: false };
    });
};